import { useMutation, MutationObserverOptions } from 'react-query';
import { RepayUmiOutput, RepayUmiInput, repayUmi } from 'clients/api';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
  RepayUmiOutput,
  Error,
  Omit<RepayUmiInput, 'userSigner'> & { accountAddress: string }
>;

const useRepayUmi = (options?: Options) =>
  useMutation(
    FunctionKey.REPAY_UMI,
    async (params: Omit<RepayUmiInput, 'userSigner'> & { accountAddress: string }) => {
      const { accountAddress, ...rest } = params;

      const { ethers } = await import('ethers');
      const provider = new ethers.providers.Web3Provider(window.ethereum as any);
      const userSigner = provider.getSigner();

      return repayUmi({
        userSigner,
        ...rest,
      });
    },
    options,
  );

export default useRepayUmi;
